import { Operator } from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import ContainsValue from './ContainsValue';
import SetValue from './SetValue';

const AttributeValueListUnique = ({
  selectedOperator,
  availableValueOptions,
  fieldName,
  showLabel,
  readOnly = false
}) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
      return (
        <EqualValue
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );
    case Operator.CONTAINS:
    case Operator.NOT_CONTAINS:
    case Operator.STARTS_WITH:
    case Operator.NOT_STARTS_WITH:
    case Operator.ENDS_WITH:
    case Operator.NOT_ENDS_WITH:
      return <ContainsValue fieldName={fieldName} showLabel={showLabel} readOnly={readOnly}/>;
    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS ATTRIBUTE IS UNDEFINED*/}</>;
    case Operator.IN_SET:
    case Operator.NOT_IN_SET:
      return (
        <SetValue
          fieldName={fieldName}
          showLabel={showLabel}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />
      );

    default:
      return <></>;
  }
};

export default AttributeValueListUnique;
